// @flow
import React from "react";

import CardFView from "./CardFView";

export default class CardFController extends React.Component {
 

  render() {
    return (
      <CardFView {...this.props} />
    );
  }
}
